module.exports = __webpack_public_path__ + "static/img/T7201.9cd9051a.png";